<template>
    <v-container class="py-0">
        <v-row class="row-company-img">
            <v-col
                class="py-0 px-0 company-img-container"
                cols="4">
                <div class="company-img">
                    <img
                        class="img-profile"
                        :src="$store.state.companyProfileImg">

                    <span
                        v-if="canView"
                        @click="goToSetting()"
                        class="setting-container">
                        <i class="setting-icon far fa-cog"></i>
                    </span>
                </div>
            </v-col>
            <v-col
                class="py-0"
                cols="8">
                    <div class="header-company">
                        {{ $vuetify.lang.t('$vuetify.companySetting.nbtc') }}
                    </div>
                    <div class="title-company">
                        {{ $vuetify.lang.t('$vuetify.companySetting.headQuarter') }}
                    </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'CompanySetting',

    data () {
        return {
            canView: false
        }
    },

    methods: {
        goToSetting () {
            this.$emit('clear-sidebar')
            this.$router.push({ name: 'CompanySetting' }, () => {})
        }
    },

    async mounted () {
        this.canView = await this.hasPermission(this.$constant.permission.COMPANY_SETTING.VIEW)
        await this.$store.dispatch('getCompanyProfileImg')
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__slot:before {
    display: none;
}

$company-img-container-margin: 0.5rem;
.company-img-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-clip: content-box;
    background-color: white;
    height: 65px;
    max-width: 65px;
    border-radius: 6px;
    margin: 0px $company-img-container-margin;
    position: relative;
}
.row-company-img {
    padding: 0rem 0.7rem;
}

.img-profile {
    width: 52px;
    max-height: 54px;
    display: flex;
}
.setting-container {
    background: #d76436;
    position: absolute;
    height: 21px;
    width: 21px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-radius: 1.25rem;
    cursor: pointer;
    position: absolute;
    bottom: -$company-img-container-margin;
    right: -$company-img-container-margin;
}
.setting-icon {
    color: white;
    font-size: 13px;
}
.header-company {
    color: white;
    font-size: 16px;
}
.title-company {
    font-size: 14px;
    color: #a8a8a8;
}
</style>
